'use strict';

function MoneyUpDashboardHomeCrypto() {
  var _this = this;

  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_CryptoController, _MoneyUpDashboardHomeBase];

  this.presenter = null;
  this.analytics = null;
  this.onComplete = function () {};

  // this._connectionIssueConfig = null;
  this._classNames = {
    preapproval: MoneyUpProductCell.classNames.inactive,
    soa: MoneyUpProductCell.classNames.active,
    inProgress: MoneyUpProductCell.classNames.active,
    noOffers: MoneyUpProductCell.classNames.inactive,
    offerExpired: MoneyUpProductCell.classNames.inactive,
    genericFS: MoneyUpProductCell.classNames.active,
    inProgressFS: MoneyUpProductCell.classNames.active
  };
  this._dataReady = false;
  this._dataReadyCallback = null;

  this.init = function () {
    this._super();
    this._onDataReady();
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    var cellSettings = {
      product: 'MogoCrypto',
      contentExtensions: {
        inactive: 'Discontinued',
        active: 'Discontinued'
      },
      classNameExtensions: this._classNames
    };

    this._createProductCell(cellSettings);
    this.onComplete(); // tell page component is loaded

    // Crypto Sunset
    var cryptoEligibility = this.presenter.models.account.eligibility.crypto === true;
    if (cryptoEligibility) {
      this.node.removeClass('hide');
    }
  };

  this._onDataReady = function () {
    this._dataReady = true;

    this._setState();
  };

  this._setState = function () {
    if (!_this.node.querySelector('.js--dashboard-product').mogo().create && _this._dataReady) {
      _this._productCell = _this._getProductCell();
      _this._productCell.setState('inactive', 'inactive');
    }
  };
}